import { tenantApi as api } from '../config/api'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    listMyCourses: build.query<ListMyCoursesApiResponse, ListMyCoursesApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/me/courses` }),
    }),
    startMyCourse: build.mutation<StartMyCourseApiResponse, StartMyCourseApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/me/courses/${queryArg.enrollmentId}/start`,
        method: 'POST',
        body: queryArg.startLearnerCourseInDto,
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as enhancedApi }
export type ListMyCoursesApiResponse = /** status 200 Successful Response */ LearnerCourseDto[]
export type ListMyCoursesApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
}
export type StartMyCourseApiResponse = /** status 200 Successful Response */ StartLearnerCourseOutDto
export type StartMyCourseApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  /** The learner's enrollment in the cycle being started. */
  enrollmentId: string
  startLearnerCourseInDto: StartLearnerCourseInDto
}
export type CourseAvailability = 'available' | 'unavailable'
export type LearnerCourseProgress = 'not_started' | 'in_progress' | 'completed'
export type LearnerCourseUnavailableReason = 'cycle_ended'
export type LearnerCourseDto = {
  /** Whether the learner can currently access the course; independent of progress. */
  availability: CourseAvailability
  /** Certificate download for the last completion; null when none exists. */
  certificate_url?: string
  course_code: string
  course_id: string
  course_name: string
  /** Variant the learner last chose, which carries the course's language and form of address; null until they start. Still reported once the variant is archived, so it can name a variant the tenant no longer offers. */
  course_variant_id?: string
  /** Launch/resume link; null until the learner has started the course (first play goes through the start route). */
  courseplay_url?: string
  /** End of the enrollment's cycle window. */
  cycle_end_date: string
  /** Cycle the enrollment belongs to. */
  cycle_id: string
  /** Start of the enrollment's cycle window. */
  cycle_start_date: string
  /** Course body text shown on the learner card. */
  description?: string
  /** Complete-by date; the cycle's end date when it sets no due date of its own. */
  due_date?: string
  duration_in_minutes: number
  /** The learner's enrollment in the shown cycle; the reference for start and per-learner state actions. */
  enrollment_id: string
  /** When the learner most recently completed this course, in any cycle - it may predate the shown one. Progress and the certificate link stay scoped to the shown cycle, so a card can carry this date while not_started. */
  last_completed_at?: string
  progress: LearnerCourseProgress
  /** Why the course is unavailable; null while availability is available. */
  reason?: LearnerCourseUnavailableReason
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type StartLearnerCourseOutDto = {
  /** Signed launch link for the started course. Short-lived to issue but long-lived once issued, so treat it as a credential. */
  courseplay_url: string
}
export type StartLearnerCourseInDto = {
  /** Variant the learner chose; sets the course's language and form of address for this participation. */
  course_variant_id: string
}
export const { useListMyCoursesQuery, useStartMyCourseMutation } = injectedRtkApi
